/* eslint-disable */
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchIcon from "@mui/icons-material/Search";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import CheckIcon from '@mui/icons-material/Check';
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import Message from "../../utils/Message";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { getLcListasPrecios } from "../../services/LcListaPrecioService";
import { getCacheData } from "../../services/CacheService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialSearchData = {
  idProveedor: null,
  idLcProducto: null,
  idLcPresentacion: null,
  estado: "habilitado",
  referencia: "todos",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const listaDeReferenciaOptions = [
  {
    id: "todos",
    descripcion: "Todas",
  },
  {
    id: "solo-referencia",
    descripcion: "Sólo las listas que son de referencia",
  },
  {
    id: "solo-no-referencia",
    descripcion: "Sólo las listas que No son de referencia",
  },
];

const nameItemsText = "Lista de Precio de Lente de Contacto";
//
// #############################################################################
//
const ListaPrecioLenteContactoTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [itemsCrud, setItemsCrud] = useState([]);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [proveedores, setProveedores] = useState([]);
  const [lcProductos, setLcProductos] = useState([]);
  const [lcPresentaciones, setLcPresentaciones] = useState([]);
  const navigate = useNavigate();
  const [valueACProveedor, setValueACProveedor] = useState({
    id: "",
    label: "",
  });
  const [inputValueACProveedor, setInputValueACProveedor] = useState("");
  const [valueACLcProducto, setValueACLcProducto] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcProducto, setInputValueACLcProducto] = useState("");
  const [valueACLcPresentacion, setValueACLcPresentacion] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACLcPresentacion, setInputValueACLcPresentacion] = useState("");

  const tableColumns = [
    {
      field: "descripcion_proveedor",
      headerName: "Proveedor",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_proveedor + (params.row.contacto_proveedor ? " - " + params.row.contacto_proveedor : "");
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lente_contacto_producto",
      headerName: "Producto",
      headerAlign: "center",
      align: "left",
      flex: 5,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lente_contacto_producto;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "descripcion_lc_presentacion",
      headerName: "Presentación",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_lc_presentacion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "habilitado",
      headerName: "Habilitado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.habilitado ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "referencia",
      headerName: "Referencia",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.referencia ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.habilitado && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() =>
                  handleClickActionCrud(params.row, "update")
                }
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.habilitado && (
            <Tooltip title="deshabilitar">
              <IconButton
                size="small"
                aria-label="disable"
                onClick={() =>
                  handleClickActionCrud(params.row, "disable")
                }
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {!params.row.habilitado && (
            <Tooltip title="habilitar">
              <IconButton
                size="small"
                aria-label="enable"
                onClick={() =>
                  handleClickActionCrud(params.row, "enable")
                }
              >
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.habilitado && !params.row.referencia && (
            <Tooltip title="Marcar como Lista de Referencia">
              <IconButton
                size="small"
                aria-label="mark-as-reference"
                onClick={() =>
                  handleClickActionCrud(params.row, "mark-as-reference")
                }
              >
                <CheckIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    paginationMode: "server",
    rowCount: totalRowsCount ?? 0,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    getRowId: (row) => row.id,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) => {
          if (count === 0) return "0 de 0";
          if (count === -1) return `${from}-${to} de más de ${to}`;
          return `${from}-${to} de ${count}`;
        },
      },
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadProveedores();
    loadLcProductos();
    loadPresentaciones();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setSearchData(initialSearchData);
    setItemsCrud([]);
    setValueACProveedor({
      id: "",
      descripcion: "",
    });
    setInputValueACProveedor("");
    setValueACLcProducto({
      id: "",
      descripcion: "",
    });
    setInputValueACLcProducto("");
    setValueACLcProducto({
      id: "",
      descripcion: "",
    });
    setInputValueACLcProducto("");
    setValueACLcPresentacion({
      id: "",
      descripcion: "",
    });
    setInputValueACLcPresentacion("");

  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const load = async () => {
    let _params = {
      idProveedor: searchData.idProveedor,
      idLcProducto: searchData.idLcProducto,
      idLcPresentacion: searchData.idLcPresentacion,
      habilitado: searchData.estado,
      referencia: searchData.referencia,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getLcListasPrecios(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      setTotalRowsCount(response.data.count);
      setItemsCrud(response.data.data);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleClickActionCrud = (itemCrud, action) => {
    if (action !== "new") {
      let _aditionalData = {
        codigo: itemCrud.codigo,
        estado: itemCrud.estado,
      };
      navigate("/lc-lprecio/" + itemCrud.id + "/" + action, { state: _aditionalData });
    } else {
      navigate("/lc-lprecio/" + action);
    }
  };
  //
  // ################################################################################
  //
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleBuscar();
    }
  };
  //
  // ################################################################################
  //
  const loadProveedores = async () => {
    const response = await getCacheData("proveedor")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion + (item.contacto ? " - " + item.contacto : "")
        });
      });
      setProveedores(_var);
    } else {
      setProveedores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadLcProductos = async () => {
    const response = await getCacheData("lente_contacto_producto")
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcProductos(_var);
    } else {
      setLcProductos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadPresentaciones = async () => {
    const response = await getCacheData("lc_presentacion");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setLcPresentaciones(_var);
    } else {
      setLcPresentaciones([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="block" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-proveedor"
                  size="small"
                  value={
                    valueACProveedor && valueACProveedor.id
                      ? valueACProveedor
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACProveedor(newValue);
                    setSearchData({
                      ...searchData,
                      idProveedor: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACProveedor}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACProveedor(newInputValue);
                  }}
                  options={proveedores}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Proveedor" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-lc-producto"
                  size="small"
                  sx={{ width: "100%", mb: 1 }}
                  value={
                    valueACLcProducto && valueACLcProducto.id
                      ? valueACLcProducto
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcProducto(newValue);
                    setSearchData({
                      ...searchData,
                      idLcProducto: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcProducto}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcProducto(newInputValue);
                  }}
                  options={lcProductos}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Producto" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-lc-presentacion"
                  size="small"
                  value={
                    valueACLcPresentacion && valueACLcPresentacion.id
                      ? valueACLcPresentacion
                      : null
                  }
                  onChange={(event, newValue) => {
                    setValueACLcPresentacion(newValue);
                    setSearchData({
                      ...searchData,
                      idLcPresentacion: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACLcPresentacion}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACLcPresentacion(newInputValue);
                  }}
                  options={lcPresentaciones}
                  getOptionLabel={(option) => option.label || ""}
                  renderInput={(params) => <TextField {...params} label="Presentación" />}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="lista-referencia-select-label">
                    Listas de Referencia
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="referencia-select-label"
                    label="Listas de Referencia"
                    id="referencia"
                    name="referencia"
                    value={searchData.referencia}
                    size="small"
                    onChange={handleChange}
                  >
                    {listaDeReferenciaOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="id-estado">
                    Estado
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="estado"
                    label="Estado"
                    id="estado"
                    name="estado"
                    value={searchData.estado}
                    size="small"
                    onChange={handleChange}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="crear nueva lista de precios">
                    <Button
                      fullWidth
                      className="btn-add"
                      variant="contained"
                      size="small"
                      onClick={() => handleClickActionCrud({}, "new")}
                      startIcon={<Add />}
                    >
                      Nueva
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={itemsCrud}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ListaPrecioLenteContactoTable;
